<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>内部转账</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <div class="page-actions">
        <div class="select">
          <div class="item" v-if="$hasPerm('tenant:public_account_transfer:add')">
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="openCreate">
              新建转账
            </el-button>
          </div>
          <div class="item">
            <el-select
              v-model="filterSide"
              placeholder="转入/转出"
              clearable
              size="mini"
              style="width: 160px"
            >
              <el-option
                v-for="item in sideOptions"
                :key="item.value || 'all'"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="item">
            <el-select
              v-model="filterUserType"
              placeholder="公共账号类型"
              clearable
              size="mini"
              style="width: 200px"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </div>
          <div class="item">
            <el-date-picker
              v-model="dateRange"
              size="mini"
              type="datetimerange"
              align="right"
              value-format="timestamp"
              unlink-panels
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 360px"
            />
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>

      <el-table :data="tableList" height="calc(100vh - 320px)" size="mini" v-loading="loading">
        <el-table-column label="转账时间" min-width="160" header-align="left" align="left">
          <template slot-scope="scope">
            {{ scope.row.createTime | moment }}
          </template>
        </el-table-column>
        <el-table-column prop="fromAccountName" label="转出账号" min-width="140" header-align="left" align="left" />
        <el-table-column prop="toAccountName" label="转入账号" min-width="140" header-align="left" align="left" />
        <el-table-column prop="coin" label="币种" width="100" header-align="left" align="left" />
        <el-table-column prop="amount" label="转账金额" min-width="120" header-align="left" align="left" />
        <el-table-column prop="openUserId" label="操作人" min-width="120" header-align="left" align="left" />
      </el-table>

      <div class="pag">
        <pagination
          :size="pagination.size"
          :total="totalCount"
          :page="pagination.page"
          @pageChanged="pageChanged"
        />
      </div>

      <CreateDialog v-model="createVisible" @success="onCreateSuccess" />
    </el-card>
  </div>
</template>

<script>
import Pagination from 'components/pagination';
import CreateDialog from './components/CreateDialog.vue';
import api from './api';
import { SIDE_OPTIONS } from './constants';

const PAGINATION = { page: 1, size: 20 };

export default {
  name: 'PublicSubjectTransfer',
  components: { Pagination, CreateDialog },
  data() {
    return {
      loading: false,
      filterSide: '',
      filterUserType: null,
      dateRange: null,
      typeOptions: [],
      sideOptions: SIDE_OPTIONS,
      tableList: [],
      totalCount: 0,
      pagination: { ...PAGINATION },
      createVisible: false,
    };
  },
  created() {
    this.loadTypes();
    this.fetchList();
  },
  methods: {
    loadTypes() {
      api.types().then((res) => {
        if (res && res.code === 0) {
          this.typeOptions = res.data || [];
        }
      });
    },
    handleSearch() {
      this.pagination.page = 1;
      this.fetchList();
    },
    handleReset() {
      this.filterSide = '';
      this.filterUserType = null;
      this.dateRange = null;
      this.pagination.page = 1;
      this.fetchList();
    },
    pageChanged({ page, size }) {
      this.pagination = { page, size };
      this.fetchList();
    },
    fetchList() {
      this.loading = true;
      const startTime = this.dateRange && this.dateRange[0] ? this.dateRange[0] : undefined;
      const endTime = this.dateRange && this.dateRange[1] ? this.dateRange[1] : undefined;
      api
        .page({
          page: this.pagination.page,
          size: this.pagination.size,
          side: this.filterSide || undefined,
          userType: this.filterUserType,
          startTime,
          endTime,
        })
        .then((res) => {
          if (res && res.code === 0) {
            const d = res.data || {};
            this.tableList = d.records || d.list || [];
            this.totalCount = d.total != null ? d.total : d.totalCount || 0;
          } else {
            this.tableList = [];
            this.totalCount = 0;
            this.$message.error((res && res.msg) || '查询失败');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openCreate() {
      this.createVisible = true;
    },
    onCreateSuccess() {
      this.pagination.page = 1;
      this.fetchList();
    },
  },
};
</script>

<style scoped>
.page-actions .select {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
}
</style>
